module.exports = __webpack_public_path__ + "img/caas3m-m@1.01934af0.webp";